// User
export const LOGIN_API = '/user/login' // Lấy danh sách tất cả user
export const GET_PROFILE_API = '/user/get_profile' // Lấy thông tin user
export const USER_VIP_API = '/user/vip/{game_id}/status' // Kiểm tra tiền nạp vào game của user
export const USER_OPEN_API = '/user/open/{game_id}/status' // Kiểm tra tiền nạp vào game trên web của user
export const USER_VXU_API = '/user/charged-vxu/{game_id}/last-month' // Lấy tổng nạp Vxu của user theo tháng
export const USER_VXU_OPEN_API = '/user/charged-vxu-open/{game_id}/last-month' // Lấy tổng nạp Vxu trên web của user theo tháng

// Slider
export const SLIDER_API = '/sliders' // Lấy danh sách tất cả slider

// Games
export const GAMES_API = '/games' // Lấy danh sách tất cả các game
export const GAME_ID_API = '/game/{game_id}' // Lấy danh sách game theo id
export const SERVER_API = '/game/{game_id}/servers' // Lấy danh sách tất cả server của game
export const ROLE_API = '/game/{game_id}/server/{server_id}/characters' // Lấy danh sách tất cả user của server

// Events
export const GIFTCODE_API = '/events/feature' // Lấy danh sách code ưu tiên hiển thị ngoài trang chủ
export const GENERAL_GIFTCODE_API = '/events/general?game_id={game_id}' // Lấy danh sách tất cả code chung
export const GAME_GIFTCODE_API = '/events/game?game_id={game_id}' // Lấy danh sách code theo game
export const SEND_GIFTCODE_API = '/events/{event_id}?puid={puid}' // Lấy danh sách code theo link được gửi qua tin nhắn
export const GIFTCODE_RECEIVED_API = '/events/received' // Lấy danh sách tất cả giftcode đã nhận
export const GAME_HISTORY_API = '/events/received?game_id={game_id}' // Lấy danh sách giftcode đã nhận theo game
export const GIFTCODE_ADD_API = '/gift-code/use' // Gửi giftcode vào thư ingame
export const SHOW_GIFTCODE_API = '/events/{event_id}' // Hiển thị chi tiết giftcode theo event id
export const VIP_GIFTCODE_API = '/events/vip?game_id={game_id}' // Lấy danh sách tất cả code vip
export const OPEN_GIFTCODE_API = '/events/open?game_id={game_id}' // Lấy danh sách tất cả code open
